import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Portal, Box, useDisclosure } from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin.js';
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { useNavigate } from "react-router-dom";
import { SidebarContext } from 'contexts/SidebarContext';
import {
  MdHome,
  MdNoteAlt,
} from 'react-icons/md';
import { FaConfluence } from "react-icons/fa";
import { authProtectedRoutes } from 'routes';
import Cookies from 'js-cookie';
import MainDashboard from 'views/admin/dashboard/index';
import SuperadminDashboard from 'components/subscriptionManagement/SuperadminDashboard';
import TaskManagement from 'views/admin/taskManagement/components/TaskManagement';
import Confluence from 'views/admin/confluence/Confluence';
import TourProvider from 'components/ProductTour/TourProvider';
import StartTourButton from 'components/ProductTour/StartTourButton';
import { decryptData } from 'utils/crypto';


// Rendered Index react component based on user role
const componentsMap = {
  MainDashboard,
  SuperadminDashboard,
  TaskManagement,
    Confluence
};

const iconsMap = {
  MdHome,
  MdHome,
  MdNoteAlt,
  FaConfluence
};

export default function Dashboard(props) {
  const processedData = localStorage.getItem('accessModules');
  const authUser = Cookies.get('authUser'); // Check for authUser
  const parsedData = processedData ? JSON.parse(processedData) : [];
  const [showTour, setShowTour] = useState(false);
  const roleid = decryptData(Cookies.get('role_id'));
  const navigate = useNavigate();


  const routes = parsedData.map((item) => {
    return {
      ...item,
      icon: React.createElement(iconsMap[item.icon], {
        width: '20px',
        height: '20px',
        color: 'inherit',
      }),
      component: componentsMap[item.component],
    };
  });

  const { ...rest } = props;
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { onOpen } = useDisclosure();

  // Redirect to login if authUser is not found
  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  // if (!sessionStorage.getItem('Logged In')) {
  //   localStorage.removeItem('authUser');
  //   return <Navigate to="/login" replace />;
  // }

  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };

  const getActiveRoute = (routes) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  // const getRoutes = (routes) => {
  //   return routes.map((route, key) => {
  //     if (route.layout === '/admin') {
  //       return (
  //         <Route
  //           path={`${route.path}`}
  //           element={<route.component />}
  //           key={key}
  //         />
  //       );
  //     }
  //     if (route.collapse) {
  //       return getRoutes(route.items);
  //     } else {
  //       return null;
  //     }
  //   });
  // };
  const getRoutes = (routes) => {
    return routes.map((route, key) => {
      if (route.layout === '/admin') {
        const isMainDashboard = route.component === MainDashboard;
        const Component = route.component;

        return (
          <Route
            path={`${route.path}`}
            element={<Component />}
            key={key}
          />
        );
      }
      if (route.collapse) {
        return getRoutes(route.items);
      } else {
        return null;
      }
    });
  };

  const getAuthProtectedRoutes = (routes) => {
    return routes.map((route, key) => {
      return (
        <Route path={`${route.path}`} element={<route.component />} key={key} />
      );
    });
  };

  document.documentElement.dir = 'ltr';

  const startTourAgain = () => {
    sessionStorage.setItem("show-tour-welcome", "true");
    sessionStorage.removeItem("sam-auto-tour");
    navigate("/admin/default");
  };

  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar
            isCollapsed={isCollapsed}
            routes={routes}
            display="none"
            {...rest}
          />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{
              base: '100%',
              xl: isCollapsed ? 'calc( 100% - 60px )' : 'calc( 100% - 230px )',
            }}
            maxWidth={{
              base: '100%',
              xl: isCollapsed ? 'calc( 100% - 60px )' : 'calc( 100% - 230px )',
            }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  setIsCollapsed={setIsCollapsed}
                  isCollapsed={isCollapsed}
                  onOpen={onOpen}
                  logoText={'SΛM LĪTΞ'}
                  brandText={getActiveRoute(routes)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>

            {getRoute() ? (
              <Box
                mx="auto"
                p={{ base: '20px', md: '30px' }}
                pe="20px"
                minH="100vh"
                pt="50px"
              >
                  <TourProvider routes={routes} />
                <Routes>
                  {getRoutes(routes)}
                  {getAuthProtectedRoutes(authProtectedRoutes)}
                  <Route
                    path="/"
                    element={<Navigate to="/admin/default" replace />}
                  />
                </Routes>
                <div
                  style={{
                    position: 'absolute',
                    bottom: '100px',
                    right: '20px',
                  }}
                >
                  {/* <ChatBot /> */}
                </div>
                 {showTour && (
                  <Box
                    position="fixed"
                    bottom="30px"
                    right="10px"
                    zIndex={10000}
                  >
                    <StartTourButton
                      defaultOpen={true}
                      onClose={() => setShowTour(false)}
                    />
                  </Box>
                )}
              </Box>
                
             
              
            ) : null}
            
            <Box>
              <Footer />
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}
